
import { ModuleManagerService } from '../services/module-manager.service';
import { ExtendService } from '../services/extend.service';

const moduleManager = new ModuleManagerService();

export function Components (config: any) {

	config.register.map(component => {
		/* tslint:disable */
		new ExtendService(moduleManager, `modules.${component.name}`, component);
	});

	return function (target) {
		moduleManager.init();
	};

}



// WEBPACK FOOTER //
// ./decorators/components.ts